import { Box, Flag, Icon } from 'common/styles';
import { IconClock } from 'common/icons';
import { durationToWords } from './utils';

export default function DurationFlag({ duration, color, hasDash = true }: { duration: string, color?: string, hasDash?: boolean }) {
  const durationWords = duration && durationToWords(duration);
  if (durationWords) return (
    <Flag style={{ display: 'flex', alignItems: 'center' }} color={color}>
      <Icon ml={1} size='inherit'><IconClock /></Icon>
      <span>{durationWords}</span>
      {hasDash && <Box mx={1}>-</Box>}
    </Flag>
  );
  return null;
}
